import * as moment from 'moment';
import * as React from 'react';
import formatCurrency from '../services/format.currency';
import categories, { expenses } from '../shared/categories';

const getCategoriesByType = type => Object.keys(categories).filter(key => categories[key].type === type);

export default ({
  className = '',
  value,
  user,
  year,
  month = null as any,
  accounts,
  onClick = value => {},
  details
}) => (
  <tr className={className}>
    {month !== null ? (
      <td>
        <b>{moment(new Date(new Date().getFullYear(), Number(month))).format('MMM')}</b>
      </td>
    ) : (
      <td />
    )}
    {details &&
      expenses.map(e => {
        return (
          <td className="hide-on-small-only" onClick={() => onClick(e + `&year=${year}&month=${month}`)}>
            {formatCurrency(value[e], user)}
          </td>
        );
      })}
    {!details && [
      <td
        className="hide-on-small-only"
        onClick={() => onClick(getCategoriesByType('yearly').join('|') + `&year=${year}&month=${month}`)}
      >
        {formatCurrency(value.yearly, user)}
      </td>,
      <td
        className="hide-on-small-only"
        onClick={() => onClick(getCategoriesByType('monthly').join('|') + `&year=${year}&month=${month}`)}
      >
        {formatCurrency(value.monthly, user)}
      </td>,
      <td
        className="hide-on-small-only"
        onClick={() => onClick(getCategoriesByType('weekly').join('|') + `&year=${year}&month=${month}`)}
      >
        {formatCurrency(value.weekly, user)}
      </td>
    ]}
    <td>
      <b>{formatCurrency(value.expenses, user)}</b>
    </td>
    <td>{formatCurrency(value.income, user)}</td>
    {Object.keys(accounts).map(e => {
      return (
        <td className="">
          <div>{formatCurrency(value.accounts[e], user)}</div>
        </td>
      );
    })}
  </tr>
);



// WEBPACK FOOTER //
// ./src/overview/row.tsx